import {
  useLoyaltyManager,
  useRetailerSettingsManager,
} from '../../../../ng-compat/hooks'

interface UseCustomerLoyaltyInfo {
  thresholdEnabled: boolean
  hasEnoughLoyalty: boolean
  showThresholdInfo: boolean
  customerLoyaltyBalance: number
  calculateCustomerThresholdValue: () => number
  getThresholdValue: () => number
}

const DISABLED_LOYALTY_INFO: UseCustomerLoyaltyInfo = {
  thresholdEnabled: false,
  hasEnoughLoyalty: false,
  showThresholdInfo: false,
  customerLoyaltyBalance: 0,
  calculateCustomerThresholdValue: () => 0,
  getThresholdValue: () => 0,
}

export const useCustomerLoyaltyInfo = (): UseCustomerLoyaltyInfo => {
  const loyaltyManager = useLoyaltyManager()
  const retailerSettingsManager = useRetailerSettingsManager()

  const isLoyaltyEnabled = retailerSettingsManager.isLoyaltyEnabled()
  if (!isLoyaltyEnabled) {
    return DISABLED_LOYALTY_INFO
  }

  const { thresholdSettings } = loyaltyManager.getLoyaltySettings() || {}
  const thresholdValue = Number(thresholdSettings?.value) || 0
  const isThresholdEnabledAtRetailer = thresholdSettings?.enabled ?? false
  const customerLoyaltyBalance = loyaltyManager.getCustomerLoyaltyBalance()

  const thresholdEnabled = isThresholdEnabledAtRetailer

  const hasEnoughLoyalty = customerLoyaltyBalance >= thresholdValue

  const showThresholdInfo =
    thresholdEnabled && customerLoyaltyBalance > 0 && !hasEnoughLoyalty

  return {
    thresholdEnabled,
    hasEnoughLoyalty,
    showThresholdInfo,
    customerLoyaltyBalance,
    calculateCustomerThresholdValue: () =>
      loyaltyManager.getCustomerLoyaltyThresholdRedemption(),
    getThresholdValue: () => thresholdValue,
  }
}
